
export class GenericConstants {

    /**
     * Allowed max lenght for Email fields
     */
    static MaxLengthEmail: number = 100;
    /**
     * Allowed max length for Phone fields
     */
    static MaxLengthPhone: number = 25;
}